import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chatSurfaceDefaultVariants = {}
const chatSurfaceCompoundVariants = []

const chatSurfaceSlotNames = [
  [
    "paper",
    "chatSurface__paper"
  ],
  [
    "field",
    "chatSurface__field"
  ],
  [
    "ghostButton",
    "chatSurface__ghostButton"
  ],
  [
    "inkButton",
    "chatSurface__inkButton"
  ],
  [
    "mono",
    "chatSurface__mono"
  ]
]
const chatSurfaceSlotFns = /* @__PURE__ */ chatSurfaceSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chatSurfaceDefaultVariants, getSlotCompoundVariant(chatSurfaceCompoundVariants, slotName))])

const chatSurfaceFn = memo((props = {}) => {
  return Object.fromEntries(chatSurfaceSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chatSurfaceVariantKeys = []
const getVariantProps = (variants) => ({ ...chatSurfaceDefaultVariants, ...compact(variants) })

export const chatSurface = /* @__PURE__ */ Object.assign(chatSurfaceFn, {
  __recipe__: false,
  __name__: 'chatSurface',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: chatSurfaceVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, chatSurfaceVariantKeys)
  },
  getVariantProps
})